import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { useClerk } from "@clerk/clerk-react";
import {
  ArrowLeftStartOnRectangleIcon,
  //BellIcon,
  Cog6ToothIcon,
  ListBulletIcon,
  UserIcon,
} from "@heroicons/react/24/outline";
import trackerSvg from "/360Tracker.svg";
import { useUserContext } from "../../hooks/useUserContext";
import { routeEndpoints } from "../../routes/routeEndpoints";

export default function Header() {
  const navigate = useNavigate();
  const { signOut } = useClerk();
  const { user } = useUserContext();

  return (
    <header className="w-full bg-white border-b border-[#E6EDEB]">
      <div className="flex items-center justify-between px-4 md:px-12 lg:px-30 py-5">
        <div className="flex items-center gap-2">
          <img
            src={trackerSvg}
            alt="360 Tracker"
            className="md:w-12 md:h-12 w-9 h-9"
          />
          <span className="md:text-xl text-sm font-semibold text-[#333333]">
            360Service
          </span>
        </div>

        <div className="flex items-center gap-5">
          {/* <button className="flex items-center justify-center md:w-10 md:h-10 w-5 h-5 rounded-lg md:border border-[#E6EDEB] cursor-pointer">
            <BellIcon className="size-5 text-[#333333]" />
          </button> */}

          <Popover>
            <PopoverButton className="flex items-center justify-center md:w-10 md:h-10 w-5 h-5 rounded-lg md:border border-[#E6EDEB] outline-none cursor-pointer">
              <UserIcon className="size-5 text-[#333333]" />
            </PopoverButton>

            <PopoverPanel
              anchor={{ to: "bottom end", gap: 8 }}
              className="w-65 rounded-xl border border-[#E6EDEB] bg-white shadow-lg outline-none"
            >
              {({ close }) => (
                <>
                  <div className="flex flex-col gap-1 px-4 py-4">
                    <p className="text-sm font-medium text-[#333333] truncate">
                      {user ? `${user.firstName} ${user.lastName}` : ""}
                    </p>
                    <p className="text-sm text-[#9196A3] truncate">
                      {user?.email ?? ""}
                    </p>
                  </div>

                  <div className="border-t border-[#E6EDEB]" />

                  <div className="flex flex-col gap-3 px-4 py-4">
                    <button
                      onClick={() => {
                        close();
                        navigate(routeEndpoints.orders);
                      }}
                      className="flex items-center gap-2 text-sm text-[#333333] cursor-pointer"
                    >
                      <ListBulletIcon className="size-5" />
                      Orders
                    </button>

                    <button
                      onClick={() => {
                        close();
                        navigate(routeEndpoints.settings);
                      }}
                      className="flex items-center gap-2 text-sm text-[#333333] cursor-pointer"
                    >
                      <Cog6ToothIcon className="size-5" />
                      Settings
                    </button>

                    <button
                      onClick={() => {
                        close();
                        signOut();
                      }}
                      className="flex items-center gap-2 text-sm text-[#FF453A] cursor-pointer"
                    >
                      <ArrowLeftStartOnRectangleIcon className="size-5" />
                      Logout
                    </button>
                  </div>
                </>
              )}
            </PopoverPanel>
          </Popover>
        </div>
      </div>
    </header>
  );
}
